const activity = {
  activity: "Aktibidad", // translated 
  activities: "Mga Aktibidad", // translated 
  dates: "mga petsa", // translated 
  location: "Lokasyon", // translated 
  languages: "Mga Wika", // translated 
  categories: "Mga Kategorya", // translated 
  ticketOption: "Opsyon sa Tiket", // translated 
  numberOfRatings: "Bilang ng mga rating", // translated 
  meetingPointInfo: "Impormasyon sa lugar ng pagpupulong", // translated 
  meetingPoint: "Tagpuan", // translated 
  meetingPoints: "Mga lugar ng pagpupulong", // translated 
  providedBy: "Ibinigay ni", // translated 
  expirationDate: "Petsa ng pag-expire", // translated 
  groupSize: "Laki ng grupo", // translated 
  features: "Mga Tampok", // translated 
  basedOn: "Batay sa", // translated 
  reviewsFromVerCustomers: "mga review mula sa mga na-verify na customer", // translated 
  excellent: "mahusay", // translated 
  great: "mahusay", // translated 
  average: "karaniwan", // translated 
  poor: "mahirap", // translated 
  bad: "masama", // translated 
  onlyBookedCustomersTooltip:
    "Tanging ang mga customer na nag-book ng aktibidad na ito ang maaaring mag-iwan ng review", // translated 
  noReviewsYet: "Sa ngayon, walang mga review para sa aktibidad na ito.", // translated 
  backToActivitiesList: "Balik sa listahan ng mga aktibidad", // translated 
  getPrices: "kumuha ng mga presyo", // translated 
  availabilityAndPrices: "Kakayahang magamit at mga presyo", // translated 
  ticketOptions: "Mga opsyon sa tiket", // translated 
  ticketInfo: "Impormasyon sa tiket", // translated 
  selectYourTickets: "Piliin ang iyong mga tiket", // translated 
  product: "Produkto", // translated 
  total: "Kabuuan", // translated 
  slot: "Puwang", // translated 
  language: "Wika", // translated 
  tickets: "Mga Tiket", // translated 
  ticketsFor: "Mga Tiket Para sa", // translated 
  previousStep: "Nakaraang hakbang", // translated 
  onlyAvailableInEnglish: "Makukuha lamang sa Ingles", // translated 
  guest: "Bisita", // translated 
  leadGuest: "Pangunahing panauhin", // translated 
  adult: "Matanda", // translated 
  child: "Bata", // translated 
  pleaseSelectAdult: "Pumili ng kahit isang nasa hustong gulang", // translated 
  notAvailableActivity: "Hindi available ang produktong ito", // translated 
  required: "Kinakailangan", // translated 
  pickupPoint: "Punto ng Pagsundo", // translated 
  pickupPoints: "Mga Punto ng Pagsundo", // translated 
  ticketType: "Uri ng Tiket", // translated 
  anonymous: "Anonymous", // translated 
  printedVoucher: "Tinatanggap ang Naka-print na Voucher", // translated 
  mobileVoucher: "Tinatanggap ang Mobile Voucher", // translated 
  mixedVoucher: "Tinatanggap ang mobile o naka-print na Voucher", // translated 
  safetyMeasures: "Mga hakbang sa kaligtasan na inilapat", // translated 
  doThisBecause: "Gawin Ito Dahil", // translated 
  safetyInfo: "Impormasyon sa Kaligtasan", // translated 
  reviewsHighestFirst: "Bilang ng mga Review (pinakamataas muna)", // translated 
  bookingFee: "Bayad sa Pag-book", // translated 
  startDate: "Petsa ng Pagsisimula", // translated 
  endDate: "Petsa ng Pagtatapos", // translated 
  cancellationDeadlineAndFees: "Huling Araw ng Pagkansela at mga Bayarin", // translated 
  resetTickets: "I-reset ang mga Tiket", // translated 
  instantConfirmation: "Agarang Kumpirmasyon", // translated 
  clickResetBtn: "Pindutin ang buton na i-reset upang simulan muli ang iyong pagpili", // translated 
  whatToRemember: "Ano ang dapat tandaan", // translated 
};


export default activity;
